import type { ReactNode } from 'react'

interface ScrollableContainerProps {
  children: ReactNode
  className?: string
}

export const ScrollableContainer = ({
  children,
  className = '',
}: ScrollableContainerProps) => {
  return (
    <div className={`h-100 ${className}`} style={{ overflowY: 'auto' }}>
      {children}
    </div>
  )
}
